import { render } from "./HelpFriendsDialog.vue?vue&type=template&id=30a35a42"
import script from "./HelpFriendsDialog.vue?vue&type=script&lang=js"
export * from "./HelpFriendsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__